module.exports = __webpack_public_path__ + "img/icon_5_60.a2f404c5.png";